import React, {createContext, useEffect } from 'react';
import { createStore, createHook } from 'react-sweet-state';
import {Audit} from "@bdfx/audit-api/types"
//import {apiGetAudit} from "../../common/api"
import {apiGetAudit} from "@bdfx/audit-api"
import ErrorPage from "../app-components/error-page"
import {getAuditId} from "../../common/helpers"

interface IState {
  data: Audit
  loading: boolean
  error: any
}

// define store initial state
const initialState: IState = {
  data: {} as Audit, 
  loading: false,
  error: {},
};
// define the actions that mutate the state
const actions = {
  fetch: (id) => async ({ getState, setState }) => {
    const state = getState()
    if (state.loading || (state.data?.id === id && state.error[id])) return;
    setState({ loading: true, error: {} }); 
    try {
      const {data} = await apiGetAudit(id);
      const preState = getState()
      setState({ data: {...preState.data, [id]: data.data }, loading: false, 
                  error: {...preState.error,[id]: data.status === "deleted" ? 403 : null, }});
    } catch (error) { 
        setState({ data: {id}, error: {...getState().error,[id]: error.response.status}, loading: false });  
        await new Promise(r => setTimeout(() => {
        }, 10000))

    } 
  }
}

// create a store type
const AuditStore = createStore({ initialState, actions });
// create components to access store state instances
const useAudit = createHook(AuditStore);

export const AuditContext = createContext([] as any);

export const AuditProvider = (props) => {
    const [state, actions] = useAudit();
    const id = getAuditId()
    const data: Audit = state.data[id]
    useEffect(() => { 
        if(!data) {
            actions.fetch(id)
        }
    }, [state,actions, id, data]);
    return (
      <AuditContext.Provider value={[data, actions.fetch]}>
        {state.error[id] ? <ErrorPage code={state.error[id]} />
        :
          props.children
        }
      </AuditContext.Provider>
    );
  };
